module.exports = __webpack_public_path__ + "static/media/prevIcon.d92fe1af.svg";